import * as React from 'react';
import { useSelector } from 'react-redux';

import Paper from '@mui/material/Paper';

import FileViewerById from '../components/fileViewerById';
import { activeEventSelector } from '../store/selectors/events.selectors';

interface IScheduleProps {}

const Schedule: React.FunctionComponent<IScheduleProps> = (props) => {
  const activeEvent = useSelector(activeEventSelector);
  return (
    <Paper className="m-4 flex flex-col p-8">
      <div className="flex flex-row items-start">
        <p className="text-3xl font-bold">Schedule</p>
      </div>
      <FileViewerById id={activeEvent?.schedule} />
    </Paper>
  );
};

export default Schedule;
